import React, { useEffect, useState, useCallback, useRef } from "react";
import { Link } from "react-router-dom";
import {
    Form,
    Input,
    Select,
    Modal,
    Typography,
    Button,
    DatePicker,
    Col,
    Row,
    TimePicker,
    notification,
    Radio,
    Checkbox,
} from "antd";
import moment from "moment";
import { InfoCircleFilled } from '@ant-design/icons';

import dayjs from "dayjs";
import ProductionApi from "../../Apis/ProductionApi";
import ProductApi from "../../Apis/ProductApi";
import StockApi from "../../Apis/StockApi";
import RecipeApi from "../../Apis/RecipeApi";
import AftreCookApi from "../../Apis/AftreCookApi";
import IngredientsApi from "../../Apis/IngredientsApi";
const { Title } = Typography;

function AfterCooking({ visible, onClose }) {
    const [formAdd] = Form.useForm();
    const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
    const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
    const currentDate = moment().format("DD/MM/YYYY");
    const currentTime = moment().format("h:mm a");
    const CURRENCY = decodedToken.currency === "USD" ? "$" : "€";

    const [Products, setProducts] = React.useState([]);
    const [ProductGroups, setProductGroups] = React.useState({});
    const [IngredientId, setIngredientId] = useState(0);
    
    const allProductsRef = useRef([]);
    const allProductGroupsRef = useRef({});
    const dataLoadedRef = useRef(false);

    const extractBaseBatchCode = (batchCode) => {
        if (!batchCode) return '';
        const match = batchCode.match(/#(.+)$/);
        if (match) {
            return match[1];
        }
        return batchCode;
    };

const fetchAllPages = useCallback(async () => {
    let currentPage = 0;
    let hasMore = true;
    let allGroups = {};

    try {
        while (hasMore) {
            const response = await ProductApi.ListproductsStock(currentPage, 10);

            if (!response?.payloadDto || response.payloadDto.length === 0) {
                hasMore = false;
                break;
            }

            // Add products directly into the global groups
            response.payloadDto.forEach((product) => {
                const productCode = product?.productCode || '';
                const baseBatchCode = extractBaseBatchCode(productCode);

                if (!baseBatchCode) return;

                // Create group if it doesn't exist
                if (!allGroups[baseBatchCode]) {
                    allGroups[baseBatchCode] = {
                        baseBatchCode: baseBatchCode,
                        ingredients: []
                    };
                }

                // Add this product to the existing group
                allGroups[baseBatchCode].ingredients.push({
                    ...product,
                    ingredientId: product.id,
                    productId: product.id,
                    productName: product.productName
                });
            });

            currentPage++;

            if (currentPage >= response.totalPages) {
                hasMore = false;
            }
        }

        // Save grouped products
        allProductGroupsRef.current = allGroups;
        setProductGroups(allGroups);

        // Convert groups to dropdown products
        const allProducts = Object.keys(allGroups).map((key) => {
            const group = allGroups[key];

            const firstProductName =
                group.ingredients[0]?.productName ||
                group.ingredients[0]?.name ||
                key;

            return {
                baseBatchCode: key,
                displayName: firstProductName,
                ingredients: group.ingredients,
                supplierCount: group.ingredients.length
            };
        });

        allProductsRef.current = allProducts;
        setProducts(allProducts);

    } catch (err) {
        console.log('Error fetching all pages:', err);
    }
}, []);



    const [Production, setProduction] = React.useState([]);
    const [time, setTime] = useState(new Date());

      useEffect(() => {
        // Reset the loaded flag when modal closes
        if (!visible) {
            dataLoadedRef.current = false;
            return;
        }

        // Load data only if not already loaded
        if (!dataLoadedRef.current) {
            fetchAllPages();
            dataLoadedRef.current = true;
        }

        const intervalID = setInterval(() => {
            setTime(new Date());
        }, 1000);

        return () => clearInterval(intervalID);
    }, [visible, fetchAllPages]);

    const formattedTimeNew = time.toLocaleTimeString();

    function convertToUnixTimestamp(dateString) {
        const parts = dateString.split("/");
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1;
        const year = parseInt(parts[2], 10);

        const unixTimestamp = Date.UTC(year, month, day);
        return unixTimestamp;
    }

    function formatDate(date) {
        const dateNew = parseInt(date, 10);
        const options = { day: "2-digit", month: "short", year: "numeric" };
        const formattedDate = new Date(dateNew).toLocaleDateString(
            "en-US",
            options
        );

        const [month, day, year] = formattedDate.split(" ");
        const capitalizedMonth = month.toUpperCase();

        return `${day} ${capitalizedMonth} ${year}`;
    }

    const handleInputKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    const toUom2 = (rawValue, unit) => {
    const val = parseFloat(rawValue);
    if (isNaN(val)) return 0;
    if (unit === StockProduct2?.unitUomOne) {
        return val * parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
    } else if (unit === StockProduct2?.unitUomTwo) {
        return val;
    } else if (unit === StockProduct2?.unitUomThree) {
        return val / parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
    }
    return val;
};

    const handleInputChange = (event, itemId) => {
    const newQuantity = event.target.value.trim();
    setSelectedItems(prevSelectedItems =>
        prevSelectedItems.map(selectedItem => {
            if (selectedItem.id !== itemId.id) return selectedItem;
            return {
                ...selectedItem,
                quantity2: newQuantity,                                   
                quantity: toUom2(newQuantity, selectedItem.unit2)        
            };
        })
    );
};

    const handleSelectChange = (event, itemId) => {
    setSelectedItems(prevSelectedItems =>
        prevSelectedItems.map(selectedItem => {
            if (selectedItem.id !== itemId.id) return selectedItem;

            const newUnit2 = event;
            const rawValue = selectedItem.quantity2; 

            return {
                ...selectedItem,
                unit2: newUnit2,
                unit: newUnit2,
                quantity: toUom2(rawValue, newUnit2) 
            };
        })
    );
};

    const handleApiError = (err, setbtnDisable) => {
        setbtnDisable(false);
        console.log(err);
        
        if (err?.apiError?.status) {
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>,
                description: err.apiError.message,
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        } else {
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Error</span>,
                description: err?.message || "An error occurred. Please try again.",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        }
    };

    const [QuantityValid, setQuantityValid] = React.useState(false);
    const [UnitValid, setUnitValid] = React.useState(false);
    const [StockValid, setStockValid] = React.useState(false);
    const [btnDisable, setbtnDisable] = useState(false);
    const submittingRef = useRef(false);

    const handleSubmit = (data) => {

    if (submittingRef.current) return;
    submittingRef.current = true;

    console.log(selectedItems);
    setbtnDisable(true);

    // Validation checks
    if (!selectedItems.length > 0) {
        setbtnDisable(false);
        setQuantityValid(false);
        setUnitValid(false);
        setStockValid(true);
        return;
    } 
    for (const item of selectedItems) {
        if (!item?.quantity || parseFloat(item?.quantity) <= 0) {
            setbtnDisable(false);
            setQuantityValid(true);
            setUnitValid(false);
            setStockValid(false);
            return;
    } 
    
        if (!item?.unit2) {
            setQuantityValid(false);
            setbtnDisable(false);
            setUnitValid(true);
            setStockValid(false);
            return;
    }

        const requestedBase = parseFloat(item.quantity);
        const availableBase = parseFloat(item.unitOfMeasurement1) || 0;
        if (requestedBase > availableBase + 0.0001) {
            setbtnDisable(false);
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Insufficient Stock</span>,
                description: `Batch ${item.batchCode}: requested ${requestedBase} ${StockProduct2?.unitUomTwo} exceeds available ${availableBase} ${StockProduct2?.unitUomTwo}`,
                closeIcon: false,
                duration: 5,
                style: { backgroundColor: "#fff2f0", color: "red" },
            });
            return;
        }
    }

    setQuantityValid(false);
    setUnitValid(false);
    setStockValid(false);

    const dateObject = new Date(data?.prodTime);
    const hours = dateObject.getHours();
    const minutes = dateObject.getMinutes();
    const formattedTime = `${hours}:${minutes < 10 ? '0' : ''}${minutes}`;

    const SelectDate = dayjs(data.createDate).format("DD/MM/YYYY");
    const sellDate = dayjs(data.coSellByDate).format("DD/MM/YYYY");

    const selectedStockItem = selectedItems[0];
    
    const stockBatchCodeList = selectedItems.map(item => `${item.batchCode}//${item.id}`);

    const totalQuantityUom2 = selectedItems.reduce(
        (sum, it) => sum + (parseFloat(it.quantity) || 0), 0
    );

    const primaryUnit = selectedItems[0]?.unit2;

    const totalQuantityInPrimaryUnit = (() => {
        const base = totalQuantityUom2;
        if (primaryUnit === StockProduct2?.unitUomOne) {
            return base / parseFloat(StockProduct2?.unitOfMeasurement2 || 1);
        }
        if (primaryUnit === StockProduct2?.unitUomThree) {
            return base * parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
        }
        return base; 
    })();

    const groupKey = extractBaseBatchCode(selectedItems[0]?.batchCode);
    const group = ProductGroups[groupKey];
    const displayName = group?.ingredients[0]?.productDTO?.productName || StockProduct2?.productName || 'Product';
    const recipeNameSnapshot = displayName; // capture at submit entry

        const totalCost = selectedItems.reduce(
        (sum, it) => sum + (parseFloat(it.quantity) || 0) * parseFloat(StockProduct2?.costPriceUoM2 || 0),
        0
    );

    const ingredientsDTOList = selectedItems.map(item => ({
        id: IngredientId,                      
        stockId: item.id,
        unit: item.unit2,
        quantity: item.quantity2,               
    }));

    const productionIngredientsList = selectedItems.map(item => ({
        ...item,
        stockId: item.id,
    }));

    let createdRecipeId = null;
    let createdProductionId = null;
    let createdAfterCookId = null;

    // Rollback function
    const rollback = async (step, error) => {
        console.error(`Rollback triggered at step: ${step}`, error);
        
        const failedDeletions = [];
        
        // Rollback in reverse order
        if (createdAfterCookId) {
            await AftreCookApi.DeleteafterCook(createdAfterCookId).catch(e => failedDeletions.push('AfterCook'));
        }
        if (createdProductionId) {
            await ProductionApi.deleteProduction(createdProductionId).catch(e => failedDeletions.push('Production'));
        }
        if (createdRecipeId) {
            await RecipeApi.DeleteRecipe(createdRecipeId).catch(e => failedDeletions.push('Recipe'));
        }
        
        setbtnDisable(false);

        if (failedDeletions.length > 0) {
            // Some rollbacks failed - alert user
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>⚠️ Manual Intervention Required</span>,
                description: `Failed to delete: ${failedDeletions.join(', ')}. Please contact support.`,
                closeIcon: false,
                duration: 10,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
            
            // Log for support
            console.error('Rollback failed for:', failedDeletions, 'Step:', step, 'Error:', error);
        } else {
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Operation Failed</span>,
                description: `Failed at step: ${step}. All changes have been rolled back.`,
                closeIcon: false,
                duration: 5,
                style: {
                    backgroundColor: "#fff2f0",
                    color: "red",
                },
            });
        }
    };

    // Step 1: Create Recipe
    let formData = JSON.stringify({
        recipeName: recipeNameSnapshot,
        unit: primaryUnit,
        quantity: totalQuantityInPrimaryUnit,
        ingredientsDTO: ingredientsDTOList,
        stockBatchCodeList: stockBatchCodeList,
        institutionDTO: {
            id: StockProduct2?.institutionDTO?.id
        },
        tenantDTO: {
            id: decodedToken?.tenantId,
            tenantApiKey: decodedToken?.tenantApiKey,
        },
    });

    const cleanedStockProduct = StockProduct2 ? {
        ...StockProduct2,
        coolingShelfLifeDTO: StockProduct2.coolingShelfLifeDTO ? {
            ...StockProduct2.coolingShelfLifeDTO,
            description: StockProduct2.coolingShelfLifeDTO.description
                ?.replace(/°/g, 'deg')
                ?.replace(/[^\x20-\x7E]/g, '') || ""
        } : null,
        description: StockProduct2.description
            ?.replace(/°/g, 'deg')
            ?.replace(/[^\x20-\x7E]/g, '') || "",
        productName: StockProduct2.productName
            ?.replace(/°/g, 'deg')
            ?.replace(/[^\x20-\x7E]/g, '') || ""
    } : null;

    RecipeApi.CreateRecipe(formData)
        .then((response) => {
            if (!response?.payload?.id) {
                throw new Error("Recipe created but no ID returned — cannot continue safely");
            }
            createdRecipeId = response.payload.id;
            
            // Step 2: Create Production
            let formData2 = JSON.stringify({
                cookingTime: formattedTime,
                sellByDate: convertToUnixTimestamp(sellDate),
                unit: primaryUnit,
                quantity: totalQuantityInPrimaryUnit,
                userId: decodedToken?.userId,
                productionName: response?.payload?.recipeName,
                currency: CURRENCY,
                batchCode: selectedItems[0]?.batchCode + "-" + response?.payload?.id,
                productionCoast: totalCost,
                allergensDTO: response?.payload.allergenDTOList,
                productionCreateDate: convertToUnixTimestamp(SelectDate),
                productDTO: cleanedStockProduct,
                uomNumber: selectedItems[0]?.unit2 === StockProduct2?.unitUomOne ? 1 : selectedItems[0]?.unit2 === StockProduct2?.unitUomTwo ? 2 : 3,
                rawProduction: true,
                stockBatchCodeList: stockBatchCodeList,
                recipeDTO: {
                    id: response?.payload?.id,
                    ingredientsDTO: [{
                        id: StockProduct2?.id,
                        ingredientsQuantityDTOList: productionIngredientsList,
                    }],
                },
                tenantDTO: {
                    id: decodedToken?.tenantId,
                    tenantApiKey: decodedToken?.tenantApiKey,
                },
                institutionDTO: {
                    id: response?.payload?.institutionDTO?.id,
                },
            });

            return ProductionApi.CreateProduction(formData2);
        })
        .then((response22) => {
            createdProductionId = response22?.payload?.id;
            
            // Step 3: Create After Cook
            let formData3 = JSON.stringify({
                dateOfCooking: response22?.payload?.productionCreateDate,
                timeOfCookingFinished: formattedTime,
                temperatureOfTheProductAfterCook: "N/A",
                batchCodeOfTheCookedProduct: selectedItems[0]?.batchCode,
                newSellByDateOfTheCookedProduct: convertToUnixTimestamp(sellDate),
                quantityOfTheCookedProduct: response22?.payload?.recipeDTO?.quantity,
                temp: "N/A",
                oubd: selectedItems[0]?.expiryDate,
                description: "",
                unit: primaryUnit,
                productionDTO: {
                    id: response22?.payload?.id,
                    institutionDTO: {
                        id: response22?.payload?.institutionDTO?.id,
                    },
                },
                userDTO: {
                    id: decodedToken?.userId,
                },
                createdBy: UserDetails?.fullName,
                institutionDTO: {
                    id: response22?.payload?.institutionDTO?.id,
                },
                tenantDTO: {
                    id: decodedToken?.tenantId,
                    tenantApiKey: decodedToken?.tenantApiKey,
                },
            });

            return AftreCookApi.CreateAftreCook(formData3);
        })
        .then((response44) => {
            createdAfterCookId = response44?.payload?.id;

            // Step 4: Update Recipe (Soft Delete)
            // let updatedFormData = JSON.stringify({
            //     recipeName: recipeNameSnapshot,
            //     unit: primaryUnit,
            //     quantity: totalQuantityInPrimaryUnit,
            //     ingredientsDTO: ingredientsDTOList,
            //     institutionDTO: {
            //         id: StockProduct2?.institutionDTO?.id
            //     },
            //     tenantDTO: {
            //         id: decodedToken?.tenantId,
            //         tenantApiKey: decodedToken?.tenantApiKey,
            //     },
            //     isDelete: true
            // });

            return RecipeApi.DeleteRecipe(createdRecipeId);
        })
        .then(() => {
            setbtnDisable(false);
            // Success - all operations completed
            notification.open({
                message: <span style={{ fontWeight: "bold" }}>Created</span>,
                description: "Created Successfully",
                closeIcon: false,
                duration: 3,
                style: {
                    backgroundColor: "#b3ffb3",
                    color: "green",
                },
            });
            setTimeout(() => {
                window.location.reload();
            }, 500);
        })
        .catch(async(err) => {
            let step = "Unknown";
            if (!createdRecipeId) step = "Recipe Creation";
            else if (!createdProductionId) step = "Production Creation";
            else if (!createdAfterCookId) step = "After Cook Creation";
            else step = "Recipe Update";
            
            await rollback(step, err);
            handleApiError(err, setbtnDisable);
        });

    if (!IngredientId) {
            setbtnDisable(false);
            notification.error({ message: "Ingredient data not loaded yet. Please wait and try again." });
            return;
        }
};

    const [StockProduct2, setStockProduct2] = React.useState();

    const handleCancel = () => {
        formAdd.resetFields();
        setSelectedItems([]);
        setStockProduct2(null);
        setProduction([]);
        setIngredientId(0)
        onClose();
    };

    // Optimized search function - filters from cached data
    const handleInputChangeProduct = (searchText) => {
        if (!searchText || searchText.trim() === '') {
            // If search is empty, show all products from cache
            setProducts(allProductsRef.current);
            return;
        }

        // Filter from cached products
        const searchLower = searchText.toLowerCase().trim();
        const filtered = allProductsRef.current.filter(product => 
            product.displayName.toLowerCase().includes(searchLower)
        );
        
        setProducts(filtered);
    };

    const [ShelfLifeProduct, setShelfLifeProduct] = React.useState(null);

    const handleChangeProduct = (value) => {
    setStockProduct2(null);
    setSelectedItems([]);
    setProduction([]);
    
    const baseBatchCode = value;
    const productGroup = ProductGroups[baseBatchCode];
    
    if (!productGroup || !productGroup.ingredients || productGroup.ingredients.length === 0) {
        console.log("No product group found for batch code:", baseBatchCode);
        notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: "No ingredients found for this batch code",
            closeIcon: false,
            duration: 3,
            style: {
                backgroundColor: "#fff2f0",
                color: "red",
            },
        });
        return;
    }
    
    const uniqueIngredients = productGroup.ingredients;
    const firstIngredient = uniqueIngredients[0];
    const productId = firstIngredient?.id;

    IngredientsApi.SingleProducts(productId) 
        .then((ingredientResponse) => {
            console.log("IngredientsApi response:", JSON.stringify(ingredientResponse, null, 2));
            
            const ingredientRecord = ingredientResponse?.payload 
            
            const actualIngredientId = ingredientRecord?.id;
            setIngredientId(actualIngredientId);
            console.log("Ingredient table ID:", actualIngredientId);
        })
        .catch((err) => {
            console.error("Failed to fetch ingredient:", err);
        });
    
    ProductApi.SingleProducts(productId).then((response) => {
        setStockProduct2(response.payload);
        const shelfLifePeriod = parseInt(response.payload?.shelfLifeDTO?.period);
        const shelfLifeperiodType = response.payload?.shelfLifeDTO?.periodType;
        setShelfLifeProduct(response.payload);
        
        // Fetch stock items for ALL ingredients
        const stockPromises = uniqueIngredients.map(ingredient => 
            StockApi.ListStockProduct(ingredient.id)
                .then(stockResponse => ({
                    ingredient: ingredient,
                    stockData: stockResponse
                }))
                .catch(err => ({
                    ingredient: ingredient,
                    stockData: null,
                    error: err
                }))
        );
        
        Promise.all(stockPromises)
            .then((allStockResponses) => {
                let allStockItems = [];
                let hasStock = false;
                
                allStockResponses.forEach(({ ingredient, stockData, error }) => {
                    if (stockData && stockData.payload && stockData.payload.length > 0) {
                        // ONLY get items with stock > 0 - filter out zero stock
                        const validStockItems = stockData.payload.filter(item => 
                            parseFloat(item.unitOfMeasurement1) > 0.01
                        );
                        
                        console.log("Valid stock items (with quantity > 0):", validStockItems);
                        
                        if (validStockItems.length > 0) {
                            hasStock = true;
                            // Add ingredient info to each stock item
                            const stockWithIngredient = validStockItems.map(item => ({
                                ...item,
                                ingredientId: ingredient.ingredientId,
                                ingredientName: ingredient.productDTO?.productName || ingredient.name,
                                supplierBatchCode: ingredient.batchCode,
                                ingredientIdValue: ingredient.id,
                                baseBatchCode: baseBatchCode,
                                supplierName: ingredient.name || 'Unknown Supplier'
                            }));
                            allStockItems = [...allStockItems, ...stockWithIngredient];
                        }
                    }
                });
                
                console.log("All stock items with stock > 0:", allStockItems);
                
                // ✅ FIXED: Sort items using endOf('day') so today's expiry is NOT expired
                const today = dayjs().endOf('day');
                const sortedStockItems = allStockItems.sort((a, b) => {
                    const aExpiry = a.expiryDate ? dayjs(a.expiryDate).endOf('day') : null;
                    const bExpiry = b.expiryDate ? dayjs(b.expiryDate).endOf('day') : null;
                    
                    const aIsExpired = aExpiry ? aExpiry.isBefore(today) : true;
                    const bIsExpired = bExpiry ? bExpiry.isBefore(today) : true;
                    
                    // Non-expired items come first
                    if (!aIsExpired && bIsExpired) return -1;
                    if (aIsExpired && !bIsExpired) return 1;
                    
                    // If both are non-expired, sort by expiry date (earliest first)
                    if (!aIsExpired && !bIsExpired) {
                        return aExpiry.isBefore(bExpiry) ? -1 : 1;
                    }
                    
                    // If both are expired, sort by expiry date (latest/most recent first)
                    if (aIsExpired && bIsExpired) {
                        return aExpiry.isAfter(bExpiry) ? -1 : 1;
                    }
                    
                    return 0;
                });
                
                setProduction(sortedStockItems);
                
                // Calculate future date based on shelf life
                const currentDate = dayjs();
                let futureDate;
                
                if (response.payload?.shelfLifeDTO?.period && response.payload?.shelfLifeDTO?.periodType) {
                    futureDate = currentDate.add(shelfLifePeriod, shelfLifeperiodType);
                } else {
                    futureDate = currentDate;
                }
                
                console.log("Current Date:", currentDate.format("YYYY-MM-DD"));
                console.log("Shelf Life:", shelfLifePeriod, shelfLifeperiodType);
                console.log("Future Date (Shelf Life):", futureDate.format("YYYY-MM-DD"));
                
                let earliestValidExpiryDate = null; 
                let latestExpiredDate = null;        
                let hasValidStock = false;
                let hasExpiredStock = false;
                
                if (sortedStockItems && sortedStockItems.length > 0) {
                    for (const item of sortedStockItems) {
                        if (item.expiryDate) {
                            const expiryDate = dayjs(item.expiryDate).endOf('day');
                            const isExpired = expiryDate.isBefore(today);
                            
                            console.log(`Item ${item.id} expiry:`, expiryDate.format("YYYY-MM-DD"), 
                                      "Quantity:", item.unitOfMeasurement1, 
                                      "Expired:", isExpired);
                            
                            if (!isExpired) {
                                // Non-expired item
                                hasValidStock = true;
                                if (!earliestValidExpiryDate || expiryDate.isBefore(earliestValidExpiryDate)) {
                                    earliestValidExpiryDate = expiryDate;
                                }
                            } else {
                                // Expired item - track the latest (most recent) expiry date
                                hasExpiredStock = true;
                                if (!latestExpiredDate || expiryDate.isAfter(latestExpiredDate)) {
                                    latestExpiredDate = expiryDate;
                                }
                            }
                        }
                    }
                }
                
                console.log("Earliest Valid Expiry Date (from non-expired items):", 
                           earliestValidExpiryDate ? earliestValidExpiryDate.format("YYYY-MM-DD") : "None");
                console.log("Latest Expired Date (most recent expiry):", 
                           latestExpiredDate ? latestExpiredDate.format("YYYY-MM-DD") : "None");
                
                // Determine the final sell by date
                let finalSellByDate;
                
                if (hasValidStock && earliestValidExpiryDate) {
                    // We have valid stock, use the earliest valid expiry
                    if (futureDate.isAfter(earliestValidExpiryDate)) {
                        // Future date exceeds valid stock expiry, use the earliest valid expiry
                        finalSellByDate = earliestValidExpiryDate.format("YYYY-MM-DD");
                        console.log("Future date exceeds valid stock expiry, using earliest valid expiry:", finalSellByDate);
                    } else {
                        // Otherwise use the calculated future date
                        finalSellByDate = futureDate.format("YYYY-MM-DD");
                        console.log("Using future date:", finalSellByDate);
                    }
                    
                    // Double check with product expiry date
                    if (response.payload?.expiryDate) {
                        const productExpiry = dayjs(response.payload.expiryDate).endOf('day');
                        const sellByDate = dayjs(finalSellByDate).endOf('day');
                        if (sellByDate.isAfter(productExpiry)) {
                            finalSellByDate = productExpiry.format("YYYY-MM-DD");
                            console.log("Sell by date exceeds product expiry, using product expiry:", finalSellByDate);
                        }
                    }
                } else if (hasExpiredStock && latestExpiredDate) {
                    // ALL stock is expired - use the latest (most recent) expiry date
                    finalSellByDate = latestExpiredDate.format("YYYY-MM-DD");
                    console.log("All stock expired, using latest expired date:", finalSellByDate);
                    
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>All Stock Expired</span>,
                        description: `All available stock is expired.`,
                        closeIcon: false,
                        duration: 5,
                        style: {
                            backgroundColor: "#fff7e6",
                            color: "#fa8c16",
                        },
                    });
                } else {
                    // No stock at all - use product expiry or future date
                    if (response.payload?.expiryDate) {
                        const productExpiry = dayjs(response.payload.expiryDate).endOf('day');
                        if (futureDate.isBefore(productExpiry)) {
                            finalSellByDate = futureDate.format("YYYY-MM-DD");
                        } else {
                            finalSellByDate = productExpiry.format("YYYY-MM-DD");
                        }
                        console.log("No stock available, using product expiry date:", finalSellByDate);
                    } else {
                        finalSellByDate = futureDate.format("YYYY-MM-DD");
                        console.log("No stock and no product expiry, using future date:", finalSellByDate);
                    }
                }
                
                formAdd.setFieldsValue({
                    coSellByDate: finalSellByDate,
                });
                
                if (!hasStock) {
                    notification.open({
                        message: <span style={{ fontWeight: "bold" }}>No Stock Available</span>,
                        description: `No stock available for any supplier of this product`,
                        closeIcon: false,
                        duration: 3,
                        style: {
                            backgroundColor: "#fff7e6",
                            color: "#fa8c16",
                        },
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                notification.open({
                    message: (
                        <span style={{ fontWeight: "bold" }}>{err.apiError?.status || "Error"}</span>
                    ),
                    description: err.apiError?.message || "Failed to fetch stock items",
                    closeIcon: false,
                    duration: 3,
                    style: {
                        backgroundColor: "#fff2f0",
                        color: "red",
                    },
                });
            });
    })
    .catch((err) => {
        console.log(err);
        notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: "Failed to fetch product details",
            closeIcon: false,
            duration: 3,
            style: {
                backgroundColor: "#fff2f0",
                color: "red",
            },
        });
    });
};

    const [selectedItems, setSelectedItems] = useState([]);

    const handleToggleStock = (item) => {
        const exists = selectedItems.some(s => s.id === item.id);
        if (exists) {
            setSelectedItems(prev => prev.filter(s => s.id !== item.id));
        } else {
            const availableStock = parseFloat(item.unitOfMeasurement1) || 0;
            const initialItem = {
                ...item,
                quantity: "0",
                quantity2: "0",
                unit2: StockProduct2?.unitUomOne || item.unit,   // default to UOM2 (matches "Qty(UOM2)" column)
                availableStockInBaseUnit: availableStock
            };
            setSelectedItems(prev => [...prev, initialItem]);
        }
    };

    function compareDates(expiryDate) {
        const today = dayjs().startOf('day');
        const expiry = dayjs(expiryDate).endOf('day');
        
        // Only expired if the expiry day is strictly BEFORE today.
        if (expiry.isBefore(today, 'day')) {
            return true;
        }
        
        const sellByDate = formAdd.getFieldValue('coSellByDate');
        
        if (sellByDate && ShelfLifeProduct?.shelfLifeDTO?.period) {
            const sellBy = dayjs(sellByDate);
            const shelfLifeDays = ShelfLifeProduct.shelfLifeDTO.periodType === 'days' 
                ? parseInt(ShelfLifeProduct.shelfLifeDTO.period)
                : ShelfLifeProduct.shelfLifeDTO.periodType === 'weeks'
                ? parseInt(ShelfLifeProduct.shelfLifeDTO.period) * 7
                : ShelfLifeProduct.shelfLifeDTO.periodType === 'months'
                ? parseInt(ShelfLifeProduct.shelfLifeDTO.period) * 30
                : parseInt(ShelfLifeProduct.shelfLifeDTO.period) * 365;
            
            const daysToSellBy = sellBy.diff(today, 'day');
            return daysToSellBy > shelfLifeDays || sellBy.isAfter(expiry);
        }
        
        if (ShelfLifeProduct?.shelfLifeDTO?.period) {
            const shelfLifeDays = ShelfLifeProduct.shelfLifeDTO.periodType === 'days' 
                ? parseInt(ShelfLifeProduct.shelfLifeDTO.period)
                : ShelfLifeProduct.shelfLifeDTO.periodType === 'weeks'
                ? parseInt(ShelfLifeProduct.shelfLifeDTO.period) * 7
                : ShelfLifeProduct.shelfLifeDTO.periodType === 'months'
                ? parseInt(ShelfLifeProduct.shelfLifeDTO.period) * 30
                : parseInt(ShelfLifeProduct.shelfLifeDTO.period) * 365;
            
            const daysUntilExpiry = expiry.diff(today, 'day');
            return daysUntilExpiry < shelfLifeDays;
        }
        
        return false;
    }

    return (
        <>
            <Modal
                footer={[]}
                width={1200}
                visible={visible}
                maskClosable={false}
                onCancel={handleCancel}
                onOk={onClose}
            >
                <Title level={4} className="text-center Primary-Font mb-4 pb-3">
                    Add to After Cook
                </Title>
                <Form
                    form={formAdd}
                    name="nest-messages"
                    layout="horizontal"
                    labelCol={{
                        span: 3,
                    }}
                    wrapperCol={{
                        span: 21,
                    }}
                    className="FormClass IndividualProduct-Model"
                    onFinish={handleSubmit}
                >
                    <>
                        <div className="Product-createDate">
                            <div className="my-3" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b className="mx-2">{currentDate}</b>
                                <img
                                    src="/assest/Images/cal.png"
                                    style={{ width: '32px' }}
                                    className="logo-png"
                                    alt="calendar"
                                />
                            </div>
                            <div className="px-2" style={{ display: 'flex', fontSize: '18px', alignItems: 'center' }}>
                                <b>{formattedTimeNew}</b> <img
                                    src="/assest/Images/time.png"
                                    style={{ width: '35px', marginLeft: '10px' }}
                                    className="logo-png"
                                    alt="time"
                                />
                            </div>

                            <Form.Item
                                name="prodTime"
                                initialValue={dayjs(currentTime, "h:mm a")}
                                className="text-lable disabled d-none"
                            >
                                <TimePicker disabled use12Hours format="h:mm a" className="form-control control-input" />
                            </Form.Item>
                        </div>

                        <div className="Product-createDate">
                            <Form.Item
                                name="createDate"
                                initialValue={dayjs(currentDate, "DD/MM/YYYY")}
                                className="disabled text-lable col-lg-6  d-none col-sm-12 col-md-7"
                            >
                                <DatePicker
                                    disabled
                                    format={"DD/MM/YYYY"}
                                    className="form-control control-input"
                                />
                            </Form.Item>
                        </div>

                        <Form.Item
                            name="productId"
                            label="Product :"
                            className="text-lable pt-3 CrossAfter"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Select Product.",
                                },
                            ]}
                        >
                            <Select
                                showSearch
                                className="control-Select mb-1"
                                placeholder="Select Product by Batch Code"
                                filterOption={false} // Disable default filtering, we handle it manually
                                onChange={(value) => handleChangeProduct(value)}
                                onSearch={handleInputChangeProduct}
                            >
                                {Products.map((option, index) => (
                                    <Select.Option 
                                        key={option.baseBatchCode + index} 
                                        value={option.baseBatchCode}
                                    >
                                        {option.displayName}
                                        {option.supplierCount > 1 && 
                                            ` (${option.supplierCount} suppliers)`
                                        }
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                        <Row gutter={24} className="mt-3">
                            <Col lg={24} md={24}>
                                <div className="dateFilterTable">
                                    <table className="table users-table">
                                        <thead>
                                            <tr style={{ verticalAlign: 'top' }}>
                                                <th className="text-center" style={{ width: '5%' }}></th>
                                                <th style={{ width: '10%' }}>Invoice #</th>
                                                <th style={{ width: '15%' }}>Batch Code</th>
                                                <th className="text-center" style={{ width: '15%' }}>OUBD<br /> <p className="mb-0 pb-0" style={{ color: 'gray', fontSize: '12px' }}>(Original Used by Date)</p></th>
                                                <th className="text-center" style={{ width: '10%' }}>Qty(UOM2)</th>
                                                <th style={{ width: '10%' }}>Qty(UOM3)</th>
                                                <th className="text-center" style={{ width: '23%' }}>Adding Qty</th>
                                            </tr>
                                        </thead>
                                        <tbody className={Production?.length > 6 ? 'tableScroll' : ''}>
                                            {Production.map((item, index) => {
                                                // Only show items with stock > 0
                                                if (parseFloat(item.unitOfMeasurement1) <= 0) return null;
                                                
                                                const isExpired = compareDates(formatDate(item?.expiryDate));
                                                if (isExpired) return null;

                                                return (
                                                <tr
                                                    key={item.id}
                                                    style={{ cursor: isExpired ? 'not-allowed' : 'pointer' }}
                                                    className={isExpired ? 'DisableFontColor2' : ''}
                                                >
                                                    <td className="CleanTable px-2 PnameClass" style={{ width: '5%', textAlign: 'center' }}>
                                                        <Checkbox
                                                            disabled={isExpired}
                                                            checked={selectedItems.some(s => s.id === item.id)}
                                                            onChange={() => handleToggleStock(item)}
                                                        />
                                                    </td>
                                                    <td className="CleanTable px-2 text-start PnameClass" style={{ width: '10%' }}>
                                                        {item?.invoiceNumber || '-'}
                                                    </td>
                                                    <td style={{ width: '15%' }}>                                             
                                                        <div style={{
                                                            overflowX: 'auto',
                                                            overflowY: 'hidden',
                                                            whiteSpace: 'nowrap',
                                                            maxWidth: '150px',
                                                            marginBottom: '10px',
                                                            marginTop: '-3px',
                                                            padding: '0px 0px 20px',
                                                            display: 'block',
                                                        }}>
                                                            {item?.batchCode || '-'}
                                                        </div>
                                                    </td>
                                                   
                                                    <td className="CleanTable px-2 PnameClass text-center" style={{ width: '15%' }}>
                                                        {formatDate(item?.expiryDate)}
                                                    </td>
                                                    <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass">
                                                        {(function() {
                                                            const value = parseFloat(item?.unitOfMeasurement1 || 1);
                                                            const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
                                                            const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);
                                                            return match ? match[0] : '0';
                                                        })()} {StockProduct2?.unitUomTwo}
                                                    </td>
                                                    <td style={{ width: '10%', textAlign: 'end' }} className="CleanTable PnameClass">
                                                       {(function() {
                                                            const value = parseFloat(item?.unitOfMeasurement1 || 1) * parseFloat(StockProduct2?.unitOfMeasurement3 || 1);
                                                            const normalStr = value.toLocaleString('fullwide', { useGrouping: false, maximumFractionDigits: 20 });
                                                            const match = normalStr.match(/^-?\d+(?:\.\d{0,2})?/);
                                                            return match ? match[0] : '0';
                                                        })()} {StockProduct2?.unitUomThree}
                                                       
                                                    </td>
                                                    <td style={{ width: '23%' }} className="CleanTable PnameClass AddingQty">
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                            <Form.Item
                                                                name={`createDate${item.id}`}
                                                                className="text-lable mx-1"
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <Input
                                                                    type="text"
                                                                    inputMode="decimal"
                                                                    style={{ textAlign: 'right', width: '80px' }}
                                                                    className=""
                                                                    disabled={isExpired || !selectedItems.some(selectedItem => selectedItem.id === item.id)}
                                                                    onChange={(event) => {
                                                                        const value = event.target.value;

                                                                        if (value === '' || /^\d*\.?\d*$/.test(value)) {
                                                                            handleInputChange(event, item);
                                                                        }
                                                                    }}
                                                                    onKeyDown={(e) => {
                                                                        const key = e.key;
                                                                        const value = e.currentTarget.value;

                                                                        const controlKeys = [
                                                                            'Backspace', 'Delete', 'Tab', 'Escape', 'Enter',
                                                                            'ArrowLeft', 'ArrowRight', 'Home', 'End'
                                                                        ];

                                                                        if (controlKeys.includes(key)) return;

                                                                        if (/^[0-9]$/.test(key)) return;

                                                                        if (key === '.' && !value.includes('.')) return;

                                                                        e.preventDefault();
                                                                    }}
                                                                />
                                                            </Form.Item>
                                                            <Form.Item
                                                                name={`unitOfMeasurement${item.id}`}
                                                                className="text-lable mx-1"
                                                                style={{ marginBottom: 0 }}
                                                            >
                                                                <Select
                                                                    className="control-Select mb-1"
                                                                    style={{ width: '80px' }}
                                                                    placeholder="-"
                                                                    onChange={(event) => handleSelectChange(event, item)}
                                                                    disabled={isExpired || !selectedItems.some(selectedItem => selectedItem.id === item.id)}
                                                                    value={selectedItems.find(selectedItem => selectedItem.id === item.id)?.unit2}
                                                                >
                                                                    <Select.Option value={StockProduct2?.unitUomOne}>{StockProduct2?.unitUomOne}</Select.Option>
                                                                    <Select.Option value={StockProduct2?.unitUomTwo}>{StockProduct2?.unitUomTwo}</Select.Option>
                                                                    {StockProduct2?.unitOfMeasurement3 != 1 && <Select.Option value={StockProduct2?.unitUomThree}>{StockProduct2?.unitUomThree}</Select.Option>}
                                                                </Select>
                                                            </Form.Item>
                                                        </div>
                                                    </td>
                                                </tr>
                                            );})}
                                        </tbody>
                                    </table>
                                    {Production.length === 0 && StockProduct2 && (
                                        <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                                            No stock available for this product from any supplier
                                        </div>
                                    )}
                                </div>
                            </Col>

                            <Col lg={12} md={12} className="d-none">
                                <Form.Item
                                    name="institutionId"
                                    className="text-lable"
                                >
                                    <Input
                                        type="text"
                                        className="control-input"
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item
                            name="coSellByDate"
                            label="Sell By Date"
                            className="text-lable"
                            rules={[
                                { required: true, message: "Sell By Date is required" },
                                {
                                    validator: (_, value) => {
                                        if (!value) return Promise.resolve();
                                        
                                        const today = dayjs().startOf('day');
                                        const selected = dayjs(value);
                                        
                                        if (selected.isBefore(today)) {
                                            return Promise.reject(new Error("Date cannot be before today"));
                                        }
                                        
                                        let maxDate = null;
                                        if (Production && Production.length > 0) {
                                            for (const item of Production) {
                                                if (item.expiryDate) {
                                                    const expiryDate = dayjs(item.expiryDate);
                                                    if (!maxDate || expiryDate.isAfter(maxDate)) {
                                                        maxDate = expiryDate;
                                                    }
                                                }
                                            }
                                        }
                                        
                                        if (selectedItems[0]?.expiryDate) {
                                            const selectedItemExpiry = dayjs(selectedItems[0].expiryDate);
                                            if (!maxDate || selectedItemExpiry.isBefore(maxDate)) {
                                                maxDate = selectedItemExpiry;
                                            }
                                        }
                                        
                                        if (maxDate && selected.isAfter(maxDate.endOf('day'))) {
                                            return Promise.reject(new Error(`Date cannot be after ${maxDate.format("DD/MM/YYYY")}`));
                                        }
                                        
                                        return Promise.resolve();
                                    }
                                }
                            ]}
                        >
                            <Input
                                type="date"
                                placeholder="Select Sell By Date"
                                className="control-input"
                                min={dayjs().format("YYYY-MM-DD")}
                                max={(() => {
                                    let maxDate = null;
                                    if (Production && Production.length > 0) {
                                        for (const item of Production) {
                                            if (item.expiryDate) {
                                                const expiryDate = dayjs(item.expiryDate);
                                                if (!maxDate || expiryDate.isAfter(maxDate)) {
                                                    maxDate = expiryDate;
                                                }
                                            }
                                        }
                                    }
                                    if (selectedItems[0]?.expiryDate) {
                                        const selectedItemExpiry = dayjs(selectedItems[0].expiryDate);
                                        if (!maxDate || selectedItemExpiry.isBefore(maxDate)) {
                                            maxDate = selectedItemExpiry;
                                        }
                                    }
                                    return maxDate ? maxDate.format("YYYY-MM-DD") : undefined;
                                })()}
                                onChange={(e) => {
                                    formAdd.setFieldsValue({ coSellByDate: e.target.value });
                                    setTimeout(() => {
                                        setProduction([...Production]);
                                    }, 100);
                                }}
                            />
                        </Form.Item>

                        <p className={StockProduct2 ? '' : 'd-none'} style={{ textAlign: 'start', fontSize: '13px', color: 'blue' }}>
                            <InfoCircleFilled style={{ fontSize: '10px' }} className="inforIcon" />
                            Shelf Life  :{StockProduct2?.shelfLifeDTO ? (<> {StockProduct2?.shelfLifeDTO?.period} {StockProduct2?.shelfLifeDTO?.periodType}</>) : ' No shelf life date specified'}
                        </p>

                        <p className={StockProduct2 ? '' : 'd-none'} style={{ textAlign: 'start', fontSize: '13px', color: 'blue' }}>
                            <InfoCircleFilled style={{ fontSize: '10px' }} className="inforIcon" />
                            Always check the OUDB with shelf life and ensure the product is safe to use.
                        </p>

                        <p style={{ color: 'red' }} className={QuantityValid ? 'mb-2' : 'd-none'}>Quantity is 0</p>
                        <p style={{ color: 'red' }} className={UnitValid ? 'mb-2' : 'd-none'}>Unit must be selected</p>
                        <p style={{ color: 'red' }} className={StockValid ? 'mb-2' : 'd-none'}>Stock record should be selected</p>

                        <div
                            className="d-flex justify-content-between pt-4"
                            style={{
                                gap: "10px",
                                padding: "16px 24px 0",
                            }}
                        >
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={btnDisable}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                Cook
                            </Button>

                            <Button
                                onClick={handleCancel}
                                style={{
                                    flex: 1,
                                    height: 40,
                                    borderRadius: 6,
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </>
                </Form>
            </Modal>
        </>
    );
}

export default AfterCooking;